import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { useUser } from 'src/hooks/useUser'
import { setSelectedLesson, UpdateUserProgress } from 'src/redux/actions'
import { getAdminAppUrl } from 'src/util/getAdminAppUrl'
import { checkAnswer } from 'src/util/helpers'

import useExerciseProgress from './useExerciseProgress'
import usePracticeUtil from './usePracticeUtil'

export const NAV_STATE = {
  NEUTRAL: 'neutral',
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  NO_LISTENING: 'noListening',
}

export const ACTIVITY_TYPE = {
  Exercise: 'Exercise',
  Vocabulary: 'Vocabulary',
  Feedback: 'Feedback',
  LessonCompleted: 'LessonCompleted',
}

const usePracticeNav = ({
  selectedAnswer,
  exerciseTodo,
  setSelectedAnswer,
  exerciseCount,
  setExerciseCount,
  vocabularyCount,
  vocabularyToDo,
  setVocabularyCount,
  activityScreen,

  setActivityScreen,
}) => {
  const dispatch = useDispatch()
  const params = useParams()
  const { moveToNextLesson } = usePracticeUtil()
  const [isSelectedAnswerCorrect, setIsSelectedAnswerCorrect] = useState(null)

  const [activeScreen, setActiveScreen] = useState(ACTIVITY_TYPE.Exercise)

  const { lessonExercises, selectedLesson, lessonExercisesProgress, lessonVocabularies, courseLeftMenu } =
    useSelector(store => store.mainReducer)
  const { isAdmin } = useUser()
  const { chapters, extraInfo } = courseLeftMenu;
  const { unitId, chapterId, lessonId } = params;

  const {
    exercisesProgressData: {
      isExerciseCompleted,
      isPronounceCompleted,
      isFeedbackCompleted,
    },
  } = useExerciseProgress(
    lessonExercises,
    lessonExercisesProgress,
    lessonVocabularies
  )

  useEffect(() => {
    setIsSelectedAnswerCorrect(null)
  }, [selectedAnswer])

  useEffect(() => {
    if (isExerciseCompleted && !isFeedbackCompleted && selectedLesson.lesson.lessonFeedback) {
      if (!lessonExercises.length) {
        setActiveScreen(ACTIVITY_TYPE.LessonCompleted)
        setActivityScreen(ACTIVITY_TYPE.LessonCompleted)
        return
      } else {
        setActiveScreen(ACTIVITY_TYPE.Feedback)
        setActivityScreen(ACTIVITY_TYPE.Feedback)
      }

    }
  }, [isFeedbackCompleted, isExerciseCompleted])

  useEffect(() => {
    const newUnitId = courseLeftMenu?.extraInfo?.unitId ?? false
    let previousLesson = {}
    let nextLesson = {}
    if (newUnitId && newUnitId === unitId) {
      const selectedChapter = chapters.find(
        chapter => chapter.chapterId === chapterId
      )
      const selectedLessonIndex = selectedChapter?.lessons.findIndex(
        lesson => lesson.id === lessonId
      )

      if (selectedLessonIndex !== -1) {
        const selectedLesson = selectedChapter?.lessons[selectedLessonIndex]

        previousLesson = selectedChapter?.lessons[selectedLessonIndex - 1]
        nextLesson = selectedChapter?.lessons[selectedLessonIndex + 1]

        dispatch(
          setSelectedLesson({
            chapter: selectedChapter?.chapterName,
            chapterId: selectedChapter?.chapterId,
            lesson: selectedLesson,
            unit: extraInfo?.unitName,
            extraInfo: extraInfo,
            previousLesson: previousLesson,
            nextLesson: nextLesson,
          })
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseLeftMenu, unitId])

  const handleSkip = () => {
    const nextCount =
      exerciseCount < exerciseTodo.length + 1 ? exerciseCount + 1 : 0
    setSelectedAnswer(null)

    setExerciseCount(nextCount)
  }

  // const handleRemindSkip = () => {
  //   const nextCount =
  //     vocabularyCount < vocabularyToDo.length - 1 ? vocabularyCount + 1 : 0
  //   setSelectedAnswer(null)
  //   setVocabularyCount(nextCount)
  // }

  const isCorrectAnswer = () => {
    return (
      checkAnswer(selectedAnswer, exerciseTodo[exerciseCount]) ||
      selectedAnswer === true
    )
  }

  const handleCheck = () => {
    const correctAnswer = isCorrectAnswer()
    setIsSelectedAnswerCorrect(correctAnswer)
  }

  const handleContinue = skip => {
    setSelectedAnswer(null)

    // if (exerciseTodo[exerciseCount]?.id && !isAdmin && !skip) {
    //   dispatch(
    //     UpdateUserProgress({
    //       course: params.courseId,
    //       unit: params.unitId,
    //       chapter: params.chapterId,
    //       lesson: params.lessonId,
    //       completedExerciseId: exerciseTodo[exerciseCount].id,
    //     })
    //   )
    //   return
    // }
    if (skip) {
      return setExerciseCount(exerciseCount + 1)
    }
    return setExerciseCount(0);
  }

  const onEditExerciseClick = () => {
    const exercise = exerciseTodo[exerciseCount]
    if (exercise) {
      window.open(
        getAdminAppUrl() + `app/exerciseDetails?_id=${exercise.id}`,
        '_blank'
      )
    }
  }
  const onEditMaterExerciseClick = () => {
    const exercise = exerciseTodo[exerciseCount]
    if (exercise) {
      window.open(
        getAdminAppUrl() +
        `app/exerciseMasters?_id=${exercise.exerciseMasterId}`,
        '_blank'
      )
    }
  }
  // const onEditVocabularyClick = () => {
  //   const vocabulary = vocabularyToDo[vocabularyCount]
  //   if (vocabulary) {
  //     window.open(
  //       getAdminAppUrl() + `app/entertainmentVocabularies?_id=${vocabulary.id}`,
  //       '_blank'
  //     )
  //   }
  // }

  const handleMoveOnNextPage = skip => {
    if (exerciseTodo[exerciseCount]?.id && !isAdmin && !skip) {
      dispatch(
        UpdateUserProgress({
          course: params.courseId,
          unit: params.unitId,
          chapter: params.chapterId,
          lesson: params.lessonId,
          completedExerciseId: exerciseTodo[exerciseCount].id,
        })
      )
    }

    // move to exercise if remaining
    if (exerciseCount < exerciseTodo.length - 1) { //chk for feedback screen
      handleContinue(skip)
      return
    }
    // move to pronounce if remaining
    const isLastExercise = exerciseCount >= exerciseTodo.length - 1


    if (activityScreen === ACTIVITY_TYPE.Feedback && skip) {
      setActivityScreen(ACTIVITY_TYPE.LessonCompleted)
      setActiveScreen(ACTIVITY_TYPE.LessonCompleted)
      return
    }
    if (isLastExercise && !isFeedbackCompleted && selectedLesson.lesson.lessonFeedback) {

      if (!lessonExercises.length) {
        setActiveScreen(ACTIVITY_TYPE.LessonCompleted)
        setActivityScreen(ACTIVITY_TYPE.LessonCompleted)
        return
      } else {
        setActiveScreen(ACTIVITY_TYPE.Feedback)
        setActivityScreen(ACTIVITY_TYPE.Feedback)
      }
      return
    }

    setActivityScreen(ACTIVITY_TYPE.LessonCompleted)
    setActiveScreen(ACTIVITY_TYPE.LessonCompleted)

  }


  return {
    handleSkip,
    handleCheck,
    onEditExerciseClick,
    handleMoveOnNextPage,
    onEditMaterExerciseClick,
    isCorrectAnswer,
    isSelectedAnswerCorrect,
    activeScreen,
  }
}

export default usePracticeNav
